module.exports = {
  url: process.env.REACT_APP_PROD_URL,
  defaultAvatar: 'default-user-image.png',
  defaultCoverPhoto: 'default-user-cover-photo.jpg'
};
